// Dependencies
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DismissedNotificationModel", {
    enumerable: true,
    get: function() {
        return DismissedNotificationModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const DismissedNotificationModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    user_id: _zod.z.instanceof(_bson.ObjectId),
    notification_id: _zod.z.instanceof(_bson.ObjectId),
    dismissed_at: _zod.z.date()
});
